module.exports = __webpack_public_path__ + "static/media/jasper-28.145f5d01.jpg";